var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockTimerSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.33,
    height: 52.33,
    viewBox: "0 0 52.33 52.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2593",
    "data-name": "Rect\\xE1ngulo 2593",
    width: 52.33,
    height: 52.33,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6654",
    "data-name": "Grupo 6654",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6653",
    "data-name": "Grupo 6653",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5451",
    "data-name": "Trazado 5451",
    d: "M28.819,50.624a21.8,21.8,0,1,1,21.8-21.8,21.829,21.829,0,0,1-21.8,21.8m0-41.428A19.624,19.624,0,1,0,48.443,28.819,19.646,19.646,0,0,0,28.819,9.2",
    transform: "translate(-2.654 -2.654)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5452",
    "data-name": "Trazado 5452",
    d: "M26.165,52.33A26.165,26.165,0,0,1,7.664,7.664a26.165,26.165,0,1,1,37,37,25.994,25.994,0,0,1-18.5,7.664m0-50.15A23.984,23.984,0,1,0,50.15,26.165,24.012,24.012,0,0,0,26.165,2.181",
    transform: "translate(0 0)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5453",
    "data-name": "Trazado 5453",
    d: "M41.426,13.557a1.091,1.091,0,0,1-1.09-1.09V8.105a1.09,1.09,0,0,1,2.181,0v4.361a1.091,1.091,0,0,1-1.09,1.09",
    transform: "translate(-15.261 -2.654)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5454",
    "data-name": "Trazado 5454",
    d: "M72.093,42.517H67.731a1.09,1.09,0,1,1,0-2.18h4.361a1.09,1.09,0,1,1,0,2.18",
    transform: "translate(-25.214 -15.261)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5455",
    "data-name": "Trazado 5455",
    d: "M41.426,73.184a1.091,1.091,0,0,1-1.09-1.09V67.732a1.09,1.09,0,0,1,2.181,0v4.361a1.091,1.091,0,0,1-1.09,1.09",
    transform: "translate(-15.261 -25.214)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5456",
    "data-name": "Trazado 5456",
    d: "M12.466,42.517H8.105a1.09,1.09,0,1,1,0-2.18h4.361a1.09,1.09,0,1,1,0,2.18",
    transform: "translate(-2.654 -15.261)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5457",
    "data-name": "Trazado 5457",
    d: "M55.473,18.032a1.078,1.078,0,0,1-.581-.17,1.089,1.089,0,0,1-.34-1.5l2.329-3.687a1.09,1.09,0,1,1,1.843,1.164L56.4,17.523a1.09,1.09,0,0,1-.923.509",
    transform: "translate(-20.576 -4.602)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5458",
    "data-name": "Trazado 5458",
    d: "M67.353,58.893a1.082,1.082,0,0,1-.581-.168L63.086,56.4a1.09,1.09,0,1,1,1.164-1.843l3.686,2.329a1.09,1.09,0,0,1-.583,2.012",
    transform: "translate(-23.676 -20.576)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5459",
    "data-name": "Trazado 5459",
    d: "M23.632,68.446a1.09,1.09,0,0,1-.921-1.673l2.328-3.686a1.09,1.09,0,1,1,1.843,1.164l-2.328,3.686a1.089,1.089,0,0,1-.923.509",
    transform: "translate(-8.529 -23.676)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5460",
    "data-name": "Trazado 5460",
    d: "M16.939,27.053a1.089,1.089,0,0,1-.581-.168l-3.686-2.329a1.09,1.09,0,0,1,1.164-1.843l3.688,2.328a1.09,1.09,0,0,1-.584,2.012",
    transform: "translate(-4.602 -8.529)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5461",
    "data-name": "Trazado 5461",
    d: "M64.34,28.29a1.09,1.09,0,0,1-.536-2.04l3.8-2.142a1.09,1.09,0,1,1,1.071,1.9l-3.8,2.143a1.084,1.084,0,0,1-.534.14",
    transform: "translate(-23.93 -9.068)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5462",
    "data-name": "Trazado 5462",
    d: "M56.492,69.228a1.088,1.088,0,0,1-.95-.555l-2.143-3.8A1.09,1.09,0,0,1,55.3,63.8l2.142,3.8a1.089,1.089,0,0,1-.413,1.484,1.078,1.078,0,0,1-.535.141",
    transform: "translate(-20.151 -23.93)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5463",
    "data-name": "Trazado 5463",
    d: "M12.4,57.582a1.09,1.09,0,0,1-.537-2.039l3.8-2.143a1.09,1.09,0,0,1,1.07,1.9l-3.8,2.142a1.075,1.075,0,0,1-.534.141",
    transform: "translate(-4.28 -20.151)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5464",
    "data-name": "Trazado 5464",
    d: "M27.2,17.292a1.087,1.087,0,0,1-.95-.555l-2.143-3.8a1.09,1.09,0,0,1,1.9-1.07l2.142,3.8a1.089,1.089,0,0,1-.415,1.484,1.077,1.077,0,0,1-.534.14",
    transform: "translate(-9.068 -4.28)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5465",
    "data-name": "Trazado 5465",
    d: "M40.1,43.371A3.271,3.271,0,1,1,43.37,40.1,3.275,3.275,0,0,1,40.1,43.371m0-4.361a1.09,1.09,0,1,0,1.09,1.09,1.092,1.092,0,0,0-1.09-1.09",
    transform: "translate(-13.934 -13.934)",
    fill: "#fc5145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5466",
    "data-name": "Trazado 5466",
    d: "M41.426,33.038a1.091,1.091,0,0,1-1.09-1.09V22.136a1.09,1.09,0,0,1,2.181,0v9.812a1.091,1.091,0,0,1-1.09,1.09",
    transform: "translate(-15.261 -7.963)",
    fill: "#fc5145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5467",
    "data-name": "Trazado 5467",
    d: "M33.937,42.517H27.4a1.09,1.09,0,1,1,0-2.18h6.541a1.09,1.09,0,1,1,0,2.18",
    transform: "translate(-9.953 -15.261)",
    fill: "#fc5145"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTimerSvg);
export default __webpack_public_path__ + "static/media/Clock-timer-svg.ef5fdfd4a99d570d0dd69a0c26bdc069.svg";
export { ForwardRef as ReactComponent };